import { apiClient } from '@/app/api/client';

export interface MigrationArticleDto {
    id: string;
    title: string;
    author_id: string;
    profile_id: string;
    status: string;
    created_at: number;
}

export interface MigrationProfileDto {
    id: string;
    name: string;
    handle: string;
    user_id: string;
}

export interface MigrationResponse {
    success: boolean;
    dryRun?: boolean;
    articleId?: string;
    targetTenantId?: string;
    migratedAssets?: number;
    message?: string;
    error?: string;
}

export const migrationApi = {
    async getTenantArticles(tenantId: string): Promise<MigrationArticleDto[]> {
        const { data } = await apiClient.get(`/api/admin/migration/tenants/${tenantId}/articles`);
        return data;
    },

    async getTenantProfiles(tenantId: string): Promise<MigrationProfileDto[]> {
        const { data } = await apiClient.get(`/api/admin/migration/tenants/${tenantId}/profiles`);
        return data;
    },

    async migrateArticle(params: {
        articleId: string;
        targetTenantId: string;
        targetAuthorId: string;
        targetProfileId: string;
        dryRun?: boolean;
    }): Promise<MigrationResponse> {
        const { data } = await apiClient.post('/api/admin/migration/migrate', params);
        return data;
    },

    async createProfile(tenantId: string, params: { name: string; handle: string; userId: string }): Promise<MigrationProfileDto> {
        const { data } = await apiClient.post(`/api/admin/migration/tenants/${tenantId}/profiles`, params);
        return data;
    },

    async getTenantOwner(tenantId: string): Promise<{ user_id: string | null }> {
        const { data } = await apiClient.get(`/api/admin/migration/tenants/${tenantId}/owner`);
        return data;
    },
};

export function useMigrationService() {
    return migrationApi;
}
